import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  Container,
  Row,
  Button,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Input,
  Spinner,
  Form,
  ButtonGroup
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { useEffect, useState, useCallback } from "react";
import CustomTable from "components/CustomTable";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaTimes, FaKey, FaFilePdf, FaPrint } from "react-icons/fa";
import copy from 'copy-to-clipboard';
import ReactPaginate from "react-paginate";
import { apiURL1 } from '../../config';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Footer from "components/Footers/Footer";

const StudentManagement = () => {
  const navigate = useNavigate();

  const [students, setStudents] = useState([]);
  const [studentId, setStudentId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [credentialsModal, setCredentialsModal] = useState(false);
  const [regeneratePasswordModal, setRegeneratePasswordModal] = useState(false);
  const [generatedCredentials, setGeneratedCredentials] = useState({ email: '', password: '' });
  const [addStudentFormData, setAddStudentFormData] = useState({
    fullName: "",
    email: "",
    registrationNumber: "",
    password: "",
  });
  const [newPassword, setNewPassword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filterName, setFilterName] = useState("");
  const [filterRegNo, setFilterRegNo] = useState("");
  const [filterEmail, setFilterEmail] = useState("");
  const [filterClass, setFilterClass] = useState("");
  const [classes, setClasses] = useState([]);
  const itemsPerPage = 10;
  const token = localStorage.getItem("token");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [printLoading, setPrintLoading] = useState(false);

  const [madrasaInfo, setMadrasaInfo] = useState({});

  const fetchStudents = useCallback(async () => {
    try {
      setIsLoading(true);
      let url = `${apiURL1}/superadmin/getAllStudents?page=${currentPage}&limit=${itemsPerPage}`;
      if (filterName) url += `&fullName=${filterName}`;
      if (filterRegNo) url += `&registrationNumber=${filterRegNo}`;
      if (filterEmail) url += `&email=${filterEmail}`;
      if (filterClass) url += `&classId=${filterClass}`;


      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`, // Send the token in Authorization header
        },
      });

      if (Array.isArray(response.data.students)) {
        setStudents(response.data.students);
        setTotalPages(response.data.totalPages);
      } else {
        toast.error("Unexpected data format from API.");
      }
      setIsLoading(false);
    } catch (error) {
      toast.error("Failed to fetch students!");
      setIsLoading(false);
    }
  }, [currentPage, filterName, filterRegNo, filterEmail, filterClass, itemsPerPage]);

  const fetchClasses = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(`${apiURL1}/superadmin/getClassName`, {
        headers: {
          Authorization: `Bearer ${token}`, // Send the token in Authorization header
        },
      });
      setClasses(response.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
      toast.error("Failed to fetch classes!");
    }
  }, []);



  useEffect(() => {
    fetchStudents();
    fetchClasses();
    fetchMadrasaInfo();
  }, [fetchStudents, fetchClasses]);

  const handleAddStudent = async (e) => {
    e.preventDefault();
    try {

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${apiURL1}/superadmin/students`,
        addStudentFormData, // The data you're sending in the POST request
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add the token to the headers
          },
        }
      );

      // const response = await axios.post(`${apiURL}/superadmin/students`, addStudentFormData);
      toast.success("Student added successfully!");
      setGeneratedCredentials({ email: addStudentFormData.email, password: addStudentFormData.password });
      setCredentialsModal(true);
      fetchStudents();
      setAddModal(false);
      setAddStudentFormData({
        fullName: "",
        email: "",
        registrationNumber: "",
        password: "",
      });
    } catch (error) {
      toast.error("Failed to add student!");
    }
  };


  const handlePrintStudent = async (studentId) => {
    setPrintLoading(true);
    try {
      const response = await axios.post(
        `${apiURL1}/superadmin/getStudentById`,
        { studentId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      setSelectedStudent(response.data.student);
      // generateStudentPDF(response.data.student);
      openPrintView(response.data.student);
    } catch (error) {
      toast.error("Error fetching student details for printing");
    } finally {
      setPrintLoading(false);
    }
  };


  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };


  const generateStudentPDF = (student) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    // School Header
    const img = new Image();
    img.src = "https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp";
    doc.addImage(img, 'WEBP', 15, 15, 30, 30);

    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text(madrasaInfo.schoolName || 'Ummu Dhardha Ladies Islamic College', 50, 22);
    doc.setFontSize(10);
    doc.text(madrasaInfo.schoolAddress || 'Meera Nagar, Beach Road, Akkaraipattu. EP. 32400. Sri Lanka.', 50, 28);
    doc.text(`Tel: ${madrasaInfo.schoolPhoneNumber || '+94 67 205 3211'} | Email: ${madrasaInfo.schoolEmail || 'info@ummudhardha.lk'}`, 50, 34);

    // Student Details
    let y = 50;
    doc.setFontSize(14);
    doc.text(`Student Report: ${student.fullName}`, pageWidth / 2, y, { align: 'center' });
    y += 10;

    // Personal Information
    doc.setFontSize(12);
    doc.text(`Registration Number: ${student.registrationNumber}`, 20, y);
    y += 8;
    doc.text(`Email: ${student.email}`, 20, y);
    y += 8;
    doc.text(`Date of Birth: ${student.dateOfBirth ? formatDate(student.dateOfBirth) : 'N/A'}`, 20, y);
    y += 8;
    doc.text(`Class: ${student.class || 'N/A'}`, 20, y);
    y += 15;

    // Fees Table
    if (student.fees && student.fees.length > 0) {
      doc.setFontSize(14);
      doc.text('Fee History', 20, y);
      y += 10;

      const feeData = student.fees.map(fee => [
        fee.receiptNumber || 'N/A',
        fee.paidDate ? new Date(fee.paidDate).toLocaleDateString() : 'N/A',
        `Rs. ${fee.amount}`,
        fee.status,
        fee.notes
      ]);

      doc.autoTable({
        startY: y,
        head: [['Receipt#', 'Date', 'Amount', 'Status', 'Notes']],
        body: feeData,
        styles: { fontSize: 10, cellPadding: 3 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255 }
      });
      y = doc.lastAutoTable.finalY + 10;
    }

    // Attendance Section
    if (student.attendance && student.attendance.length > 0) {
      doc.setFontSize(14);
      doc.text('Attendance Record', 20, y);
      y += 10;

      const attendanceData = student.attendance.map(record => [
        new Date(record.date).toLocaleDateString(),
        record.status
      ]);

      doc.autoTable({
        startY: y,
        head: [['Date', 'Status']],
        body: attendanceData,
        styles: { fontSize: 10, cellPadding: 3 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255 }
      });
    }

    // Footer
    doc.setFontSize(8);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, pageWidth - 40, doc.internal.pageSize.getHeight() - 10);

    doc.save(`student-report-${student.registrationNumber}.pdf`);
  };

  const fetchMadrasaInfo = async () => {
    try {
      const response = await axios.get(`${apiURL1}/superadmin/school-settings`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data;
      if (data && data.length > 0) {
        setMadrasaInfo(data[0]);
      }
    } catch (error) {
      console.error('Error fetching madrasa info:', error);
    }
  };

  const openPrintView = (student) => {
    const printContent = `
    <html>
      <head>
        <title>Student Report - ${student.fullName}</title>
        <style>
          @page { margin: 20px; }
          body { font-family: Arial; margin: 20px; }
          .header { text-align: center; margin-bottom: 20px; }
          .logo { width: 100px; height: 100px; }
          .school-info { margin-bottom: 15px; }
          table { width: 100%; border-collapse: collapse; margin: 15px 0; }
          th { background-color: #2980b9; color: white; padding: 8px; }
          td { padding: 8px; border: 1px solid #ddd; }
          .section-title { font-size: 16px; margin: 20px 0 10px; }
          .sub-section { margin-left: 15px; margin-top: 10px; }
        </style>
      </head>
      <body>
        <div class="header">
          <img src="https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp" 
               class="logo" alt="School Logo">
          <div class="school-info">
            <h2>${madrasaInfo.schoolName || 'Ummu Dhardha Ladies Islamic College'}</h2>
            <p>${madrasaInfo.schoolAddress || 'Meera Nagar, Beach Road, Akkaraipattu. EP. 32400. Sri Lanka.'}</p>
            <p>Tel: ${madrasaInfo.schoolPhoneNumber || '+94 67 205 3211'} | Email: ${madrasaInfo.schoolEmail || 'info@ummudhardha.lk'}</p>
          </div>
        </div>

        <h2>Student Report: ${student.fullName}</h2>
        
        <div class="section">
          <h3 class="section-title">Personal Information</h3>
          <p>Registration Number: ${student.registrationNumber}</p>
          <p>Name with Initials: ${student.nameWithInitial || 'N/A'}</p>
          <p>Email: ${student.email || 'N/A'}</p>
          <p>Date of Birth: ${student.dateOfBirth ? formatDate(student.dateOfBirth) : 'N/A'}</p>
          <p>Class: ${student.className || 'N/A'}</p>
          <p>Address: ${student.address || 'N/A'}</p>
          <p>Desired Learning Area: ${student.desiredAreaToLearn || 'N/A'}</p>
          <p>Preferred Lesson Time: ${student.selectLessonTime || 'N/A'}</p>
          
          <div class="sub-section">
            <h4>Father/Guardian Details</h4>
            <p>Name: ${student.fatherGuardianDetails?.name || 'N/A'}</p>
            <p>Relationship: ${student.fatherGuardianDetails?.relationship || 'N/A'}</p>
            <p>Profession: ${student.fatherGuardianDetails?.profession || 'N/A'}</p>
            <p>Address: ${student.fatherGuardianDetails?.address || 'N/A'}</p>
            <p>Phone: ${student.fatherGuardianDetails?.phoneNumber || 'N/A'}</p>
          </div>
        </div>

        <!-- Rest of the existing content (Fee History and Attendance tables remain same) -->
        ${student.fees && student.fees.length > 0 ? `
          <div class="section">
            <h3 class="section-title">Fee History</h3>
            <table>
              <tr>
                <th>Receipt#</th>
                <th>Date</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Notes</th>
              </tr>
              ${student.fees.map(fee => `
                <tr>
                  <td>${fee.receiptNumber || 'N/A'}</td>
                  <td>${fee.paidDate ? formatDate(fee.paidDate) : 'N/A'}</td>
                  <td>Rs. ${fee.amount}</td>
                  <td>${fee.status}</td>
                  <td>${fee.notes}</td>
                </tr>
              `).join('')}
            </table>
          </div>
        ` : ''}

        ${student.attendance && student.attendance.length > 0 ? `
          <div class="section">
            <h3 class="section-title">Attendance Record</h3>
            <table>
              <tr>
                <th>Date</th>
                <th>Status</th>
              </tr>
              ${student.attendance.map(record => `
                <tr>
                  <td>${formatDate(record.date)}</td>
                  <td>${record.status}</td>
                </tr>
              `).join('')}
            </table>
          </div>
        ` : ''}

        <div class="footer">
          Generated on: ${new Date().toLocaleDateString()}
        </div>
      </body>
    </html>
  `;

    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };

  const handleDeleteStudent = async () => {
    try {
      const response = await axios.delete(
        `${apiURL1}/superadmin/students/${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add the token to the headers
          },
        }
      );
      toast.success("Student deleted successfully!");
      fetchStudents();
      setDeleteModal(false);
    } catch (error) {
      toast.error("Failed to delete student!");
    }
  };

  const handleApproveStudent = async () => {
    try {
      const response = await axios.put(
        `${apiURL1}/superadmin/students/${studentId}`,
        { isApproved: true },  // Request payload
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in the headers
          },
        }
      );
      toast.success("Student approved successfully!");
      fetchStudents();
      setApproveModal(false);
    } catch (error) {
      toast.error("Failed to approve student!");
    }
  };
  const handleRegeneratePassword = async () => {
    try {
      const response = await axios.put(
        `${apiURL1}/superadmin/student/change-password/${studentId}`,
        { newPassword },  // Request payload
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include token in the headers
          },
        }
      );
      if (response.status === 200) {
        toast.success("Student password updated successfully!");
        setGeneratedCredentials({ email: students.find(student => student._id === studentId)?.email, password: newPassword });
        setRegeneratePasswordModal(false);
        setCredentialsModal(true);
      } else {
        toast.error("Error updating student password");
      }
    } catch (error) {
      toast.error("Error updating student password");
    }
  };

  const columns = ["Registration", "Student Code", "Name", "Email", "Class", "Current Month Fee", "Pending Amount", "Actions"];

  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    setAddStudentFormData({ ...addStudentFormData, [name]: value });
  };

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const handleCopyToClipboard = () => {
    copy(`${generatedCredentials.email}\n${generatedCredentials.password}`);
    toast.success("Credentials copied to clipboard!");
    setCredentialsModal(false);
  };

  const handleFilterChange = (filterType, value) => {
    switch (filterType) {
      case 'name':
        setFilterName(value);
        break;
      case 'regNo':
        setFilterRegNo(value);
        break;
      case 'email':
        setFilterEmail(value);
        break;
      case 'class':
        setFilterClass(value);
        break;
      default:
        break;
    }
    setCurrentPage(1); // Reset to first page on filter change
  };

  const generateReport = async () => {
    setIsLoading(true);
    try {
      // Fetch all students without pagination
      let url = `${apiURL1}/superadmin/getAllStudents?limit=0`; // Limit 0 fetches all
      if (filterName) url += `&fullName=${filterName}`;
      if (filterRegNo) url += `&registrationNumber=${filterRegNo}`;
      if (filterEmail) url += `&email=${filterEmail}`;
      if (filterClass) url += `&classId=${filterClass}`;

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`, // Include token in the headers
        },
      });
      const allStudents = response.data.students;

      // Initialize jsPDF
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const margin = 10;
      let y = 50;

      // School Logo and Information (Header)

      const img = new Image();
      img.src = "https://res.cloudinary.com/djg7v9dna/image/upload/v1742946371/mi0wavjsehps20kdzaet.png";

      doc.addImage(img, 'PNG', 15, 15, 30, 30);

      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text(madrasaInfo.schoolName || 'Madrasa Name', 50, 22);
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text(madrasaInfo.schoolAddress || 'Madrasa Address', 50, 28);
      doc.text(`Tel: ${madrasaInfo.schoolPhoneNumber || 'Phone'} | Email: ${madrasaInfo.schoolEmail || 'Email'}`, 50, 34);

      // Report Title
      doc.setFontSize(18);
      doc.text('Student Information Report', pageWidth / 2, 55, { align: 'center' });

      // Function to add a student card to the PDF
      const addStudentCard = async (student, index) => {
        if (y > doc.internal.pageSize.getHeight() - 70) {
          doc.addPage();
          y = 50;
        }

        // Add student details
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text(`Student #${index + 1}`, margin, y);
        y += 8;

        doc.setFont('helvetica', 'normal');
        doc.text(`Name: ${student.fullName}`, margin, y);
        y += 6;

        doc.text(`Registration: ${student.registrationNumber}`, margin, y);
        y += 6;

        doc.text(`Email: ${student.email}`, margin, y);
        y += 6;

        doc.text(`Class: ${student.className}`, margin, y);
        y += 6;

        doc.text(`Current Month Fee: ${student.currentMonthStatus}`, margin, y);
        y += 6;

        doc.text(`Pending Amount: ${student.pendingAmount}`, margin, y);
        y += 6;

        // Add profile picture if available
        if (student.picture) {
          try {
            const imgDataUri = student.picture;
            doc.addImage(imgDataUri, 'JPEG', margin, y, 40, 40);
            y += 45;
          } catch (imgError) {
            console.error("Error adding image:", imgError);
            doc.text('Error loading image', margin, y);
            y += 10;
          }
        }

        doc.line(margin, y - 4, margin + 170, y - 4);
      };

      // Add each student as a card
      for (let i = 0; i < allStudents.length; i++) {
        await addStudentCard(allStudents[i], i);
        y += 10;
      }

      // Footer
      const totalPages = doc.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        doc.text(`Generated on: ${new Date().toLocaleDateString()} | ${madrasaInfo.schoolName || 'Madrasa Name'}`,
          pageWidth - 40, doc.internal.pageSize.getHeight() - 10);
      }

      // Save the PDF
      doc.save('student_report.pdf');
      toast.success("Report generated successfully!");
    } catch (error) {
      console.error("Error generating report:", error);
      toast.error("Failed to generate report!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Button
              className="d-block ml-auto mb-2"
              color="secondary"
              onClick={() => {
                setAddStudentFormData({ registrationNumber: "", fullName: "", email: "", password: "" });
                setAddModal(true)
              }}
            >
              Add Student
            </Button>

            <Card className="shadow">
              <CardHeader className="border-0 px-0 px-md-2 d-flex justify-content-between align-items-center">
                <Col xs="auto">
                  <h3 className="mb-0">Students</h3>
                </Col>
                <Col className="d-flex justify-content-end">
                  <FormGroup className="mr-2">
                    <Input
                      type="text"
                      placeholder="Filter by Name"
                      value={filterName}
                      onChange={(e) => handleFilterChange('name', e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="mr-2">
                    <Input
                      type="text"
                      placeholder="Filter by Reg No"
                      value={filterRegNo}
                      onChange={(e) => handleFilterChange('regNo', e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="mr-2">
                    <Input
                      type="text"
                      placeholder="Filter by Email"
                      value={filterEmail}
                      onChange={(e) => handleFilterChange('email', e.target.value)}
                    />
                  </FormGroup>
                  <FormGroup className="mr-2">
                    <Input
                      type="select"
                      value={filterClass}
                      onChange={(e) => handleFilterChange('class', e.target.value)}
                    >
                      <option value="">All Classes</option>
                      {classes.map(cls => (
                        <option key={cls._id} value={cls._id}>
                          {cls.className}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                  <Button color="primary" onClick={generateReport} disabled={isLoading}>
                    {isLoading ? <Spinner size="sm" /> : <FaFilePdf />} Generate Report
                  </Button>
                </Col>
              </CardHeader>
              {isLoading ? (
                <Spinner size="lg" className="my-5 mx-auto" />
              ) : (
                <CustomTable
                  columns={columns}
                  rows={students ? students.map((student) => ({
                    Registration: student.registrationNumber,
                    "Student Code": student.studentCode,
                    Name: student.fullName,
                    Email: student.email,
                    Class: student.className,
                    "Current Month Fee": student.currentMonthStatus,
                    "Pending Amount": student.pendingAmount,
                    actions: (
                      <>


                        <ButtonGroup size="sm">
                          <Button color="info" className="mr-1" onClick={() => {
                            setDeleteModal(true);
                            setStudentId(student._id);
                          }}>
                            <i className="fas fa-user-times"></i>
                          </Button>
                          <Button color="primary" className="mr-1" onClick={() => navigate(`/admin/student-details/${student._id}`)}>
                            <i className="fa-regular fa-eye"></i>
                          </Button>
                          <Button color="danger" className="mr-1" onClick={() => {
                            setStudentId(student._id);
                            setRegeneratePasswordModal(true);
                          }}>
                            <FaKey />
                          </Button>
                          <Button color="secondary" onClick={() => handlePrintStudent(student._id)}>
                            <FaPrint />
                          </Button>
                        </ButtonGroup>
                      </>
                    ),
                  })) : []}
                />
              )}
              <CardFooter className="py-4">
                <Pagination
                  className="pagination justify-content-end mb-0"
                  listClassName="justify-content-end mb-0"
                >
                  <ReactPaginate
                    previousLabel={
                      <i
                        className="previous fa fa-chevron-left"
                        aria-hidden="true"
                      ></i>
                    }
                    nextLabel={
                      <i
                        className="next fa fa-chevron-right"
                        aria-hidden="true"
                      ></i>
                    }
                    breakLabel={"..."}
                    pageCount={totalPages}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination justify-content-end mb-0"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    activeClassName={"active"}
                    previousClassName={"page-item"}
                    nextClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                  />
                </Pagination>
              </CardFooter>
            </Card>
          </div>
        </Row>

        {/* Add Student Modal */}
        <Modal isOpen={addModal} toggle={() => setAddModal(false)}>
          <ModalHeader>Add Student
            <Button
              className="close"
              onClick={() => setAddModal(false)}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              <FaTimes />
            </Button>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={handleAddStudent}>
              <FormGroup>
                <Input
                  type="number"
                  name="registrationNumber"
                  value={addStudentFormData.registrationNumber}
                  onChange={handleAddInputChange}
                  placeholder="Regsitration Number"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Input
                  type="text"
                  name="fullName"
                  value={addStudentFormData.fullName}
                  onChange={handleAddInputChange}
                  placeholder="Student Name"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Input
                  type="email"
                  name="email"
                  value={addStudentFormData.email}
                  onChange={handleAddInputChange}
                  placeholder="Student Email"
                  autoComplete="new-email"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Input
                  type="password"
                  name="password"
                  value={addStudentFormData.password}
                  onChange={handleAddInputChange}
                  placeholder="Password"
                  autoComplete="new-password"
                  required
                />
              </FormGroup>
              <Button color="danger" type="submit">Add Student</Button>
            </Form>
          </ModalBody>
        </Modal>

        {/* Delete Student Modal */}
        <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
          <ModalHeader>Delete Student
            <Button
              className="close"
              onClick={() => setDeleteModal(false)}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              <FaTimes />
            </Button>
          </ModalHeader>
          <ModalBody>
            <p>Are you sure you want to delete this student?</p>
            <Button color="danger" onClick={handleDeleteStudent}>
              Yes, Delete
            </Button>
            <Button color="secondary" onClick={() => setDeleteModal(false)}>
              Cancel
            </Button>
          </ModalBody>
        </Modal>

        {/* Approve Student Modal */}
        <Modal isOpen={approveModal} toggle={() => setApproveModal(false)}>
          <ModalHeader>Approve Student
            <Button
              className="close"
              onClick={() => setApproveModal(false)}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              <FaTimes />
            </Button>
          </ModalHeader>
          <ModalBody>
            <p>Do you want to approve this student?</p>
            <Button color="success" onClick={handleApproveStudent}>
              Yes, Approve
            </Button>
            <Button color="secondary" onClick={() => setApproveModal(false)}>
              Cancel
            </Button>
          </ModalBody>
        </Modal>
        {/* Regenerate Password Modal */}
        <Modal isOpen={regeneratePasswordModal} toggle={() => setRegeneratePasswordModal(false)}>
          <ModalHeader>Regenerate Password
            <Button
              className="close"
              onClick={() => setRegeneratePasswordModal(false)}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              <FaTimes />
            </Button>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={(e) => {
              e.preventDefault();
              handleRegeneratePassword();
            }}>
              <FormGroup>
                <Input
                  type="password"
                  name="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="New Password"
                  required
                />
              </FormGroup>
              <Button color="primary" type="submit">Regenerate Password</Button>
            </Form>
          </ModalBody>
        </Modal>
        {/* Show Credentials Modal */}
        <Modal isOpen={credentialsModal} toggle={() => setCredentialsModal(false)}>
          <ModalHeader>Credentials
            <Button
              className="close"
              onClick={() => setCredentialsModal(false)}
              style={{ position: 'absolute', top: '10px', right: '10px' }}
            >
              <FaTimes />
            </Button>
          </ModalHeader>
          <ModalBody className="pb-0 d-flex flex-column justify-content-center align-items-center">
            <p>Email: {generatedCredentials.email}</p>
            <p>Password: {generatedCredentials.password}</p>
            <Button
              color="primary"
              onClick={handleCopyToClipboard}
              className="mt-4 w-100 mb-10"
              style={{ marginBottom: "1rem" }}
            >
              Copy Credentials
            </Button>
          </ModalBody>
        </Modal>
        <Footer />
      </Container>
    </>
  );
};

export default StudentManagement;
